import danImg from "@/images/testimonials/dan.jpg";
import danielImg from "@/images/testimonials/daniel.jpg";
import debImg from "@/images/testimonials/deb.jpg";
import sethImg from "@/images/testimonials/seth.jpg";
import danaImg from "@/images/testimonials/dana.jpg";
import debraImg from "@/images/testimonials/debra.jpg";
import brianImg from "@/images/testimonials/brian.jpg";
import ashlynImg from "@/images/testimonials/ashlyn.jpg";
import annImg from "@/images/testimonials/ann.jpg";

export const TESTIMONIALS = [
  {
    body: "I've been an independent for 52 years, never voting in a primary. I find the newsletter both intuitive and informative, helping me research the issues, consider all sides, and avoid aligning with a particular party. I also love the today in history section!",
    highlight: "consider all sides, and avoid aligning with a particular party",
    author: {
      name: "Ann D.",
      handle: "Columbus, OH",
      imageUrl: annImg,
    },
  },
  {
    body: "The summaries are fantastic. They provide clear, quick breakdowns of liberal and conservative POVs, which really helps me understand the full context.",
    highlight: "breakdowns of liberal and conservative POVs",
    author: {
      name: "Daniel Z.",
      handle: "El Paso, TX",
      imageUrl: danielImg,
    },
  },
  {
    body: "I love the newsletter! It gives me a quick rundown of major political stories in under 60 seconds, plus insight into which narratives each side is pushing.",
    highlight: "which narratives each side is pushing",
    author: {
      name: "Brian W.",
      handle: "New York, NY",
      imageUrl: brianImg,
    },
  },
  {
    body: "Every morning I wake up and check Pano. It gives me a quick summary of what's happening around the world and across different political perspectives.",
    highlight: "what's happening around the world",
    author: {
      name: "Ashlyn B.",
      handle: "Austin, TX",
      imageUrl: ashlynImg,
    },
  },
  {
    body: "Pano is the first thing I open in the morning. It gives me the context and perspective I need to understand what's happening in the world. Clear, concise, and worth every penny.",
    highlight: "context and perspective",
    author: {
      name: "Dan B.",
      handle: "Austin, TX",
      imageUrl: danImg,
    },
  },
  {
    body: "Pano gives me both sides of the story in one place. Their daily newsletter gives concise perspectives, saving me time and helping me understand the full picture.",
    highlight: "understand the full picture",
    author: {
      name: "Debra G.",
      handle: "Long Island, NY",
      imageUrl: debraImg,
    },
  },
  {
    body: "In a world of biased news, Pano lets me see things from all angles. It's so refreshing to get unfiltered, zinc reporting and make my own judgments without the spin.",
    highlight: "make my own judgments without the spin",
    author: {
      name: "Dana D.",
      handle: "Boston, MA",
      imageUrl: danaImg,
    },
  },
  {
    body: "I'm an avid New York Times reader, but have always felt like there's more out there. Pano keeps me up on stories from more right-leaning outlets that I might otherwise overlook.",
    highlight:
      "Pano keeps me up on stories from more right-leaning outlets that I might otherwise overlook",
    author: {
      name: "Deb L.",
      handle: "Cincinnati, OH",
      imageUrl: debImg,
    },
  },
  {
    body: "Pano has the fastest news summary on the market. The updates keep me balanced and informed on a daily basis.",
    highlight: "fastest news summary on the market",
    author: {
      name: "Seth R.",
      handle: "Chicago, IL",
      imageUrl: sethImg,
    },
  },
];
